/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber8 = createReactComponent("number-8", "IconNumber8", [
  ["path", { d: "M12 8m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-0" }],
  ["path", { d: "M12 16m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-1" }]
]);

export { IconNumber8 as default };
//# sourceMappingURL=IconNumber8.js.map
